// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"403":"c75a44c9","869":"ce3f043e"}[chunkId] + ".chunk.js";
};